/**
 * React Starter Kit (https://www.reactstarterkit.com/)
 *
 * Copyright © 2014-2016 Kriasoft, LLC. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */

export default {
  path: '/etl',
  name: 'etl',
  children: [
    {
      path: '/:type(salons|products|reps|sales|masterproducts|kpis|)',
      name: 'etl-index',
      load: () => import(/* webpackChunkName: 'etl' */ './default'),
    },
  ],
  action({ next, store, url }, { siteId }) {
    const state = store.getState();
    const modules =
      (((state.session || {}).USER_DATA || {}).group || {}).modules || [];
    if (!modules.includes('etl')) {
      return {
        redirect: `/${siteId}/forbidden?redirect=${encodeURIComponent(
          url || '',
        )}`,
      };
    }
    return next();
  },
};



// WEBPACK FOOTER //
// ./src/routes/client/site/etl/index.js